import { render, staticRenderFns } from "./GiftVoucherActionBtns.vue?vue&type=template&id=0e0c8259&"
import script from "./GiftVoucherActionBtns.vue?vue&type=script&lang=js&"
export * from "./GiftVoucherActionBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports